import { NgModule } from "@angular/core";
import { SafeHtmlTextPipe } from "./SafeHtmlText.pipe";

@NgModule({
    declarations: [SafeHtmlTextPipe],
    imports: [],
    exports: [SafeHtmlTextPipe],
})
export class FusePipesModule {}
